import { render, staticRenderFns } from "./DocProductPage.vue?vue&type=template&id=5452884a"
import script from "./DocProductPage.vue?vue&type=script&lang=js"
export * from "./DocProductPage.vue?vue&type=script&lang=js"
import style0 from "./DocProductPage.vue?vue&type=style&index=0&id=5452884a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports